var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!./documents.ts"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-a7589a50\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./documents.vue.html"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/ged/documents.vue.html
// module id = u0j4
// module chunks = 2